import { Injectable } from '@angular/core';
import { ApiService } from '@core/providers/http/api.service';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { HttpParams } from '@angular/common/http';
import { EspecialidadeFuncao } from '../api';

@Injectable({
  providedIn: 'root',
})
export class ProfissionaisEnumService {
  private readonly path = 'profissionais';
  public params = new HttpParams();

  constructor(private apiService: ApiService) { }

  getAllAnoExperiencia(): Observable<any> {
    return this.apiService.get(
      `${this.path}/api/enums/getAllAnoExperiencia`,
      this.getParams(),
      true
    );
  }

  getAllEstadoCandidatura(): Observable<any> {
    return this.apiService.get(
      `${this.path}/api/enums/getAllEstadoCandidatura`,
      this.getParams(),
      true
    );
  }

  getAllEstadoContrato(): Observable<any> {
    return this.apiService.get(
      `${this.path}/api/enums/getAllEstadoContrato`,
      this.getParams(),
      true
    );
  }

  getAllEstadoProfissional(): Observable<any> {
    return this.apiService.get(
      `${this.path}/api/enums/getAllEstadoProfissional`,
      this.getParams(),
      true
    );
  }

  getAllEstadoVaga(): Observable<any> {
    return this.apiService.get(
      `${this.path}/api/enums/getAllEstadoVaga`,
      this.getParams(),
      true
    );
  }

  getAllNivelHabilitacao(): Observable<any> {
    return this.apiService.get(
      `${this.path}/api/enums/getAllNivelHabilitacao`,
      this.getParams(),
      true
    );
  }

  getAllNivelLingua(): Observable<any> {
    return this.apiService.get(
      `${this.path}/api/enums/getAllNivelLingua`,
      this.getParams(),
      true
    );
  }

  getAllRegimeTrabalho(): Observable<any> {
    return this.apiService.get(
      `${this.path}/api/enums/getAllRegimeTrabalho`,
      this.getParams(),
      true
    );
  }

  getAllSector(): Observable<any> {
    return this.apiService.get(
      `${this.path}/api/enums/getAllSector`,
      this.getParams(),
      true
    );
  }

  getAllTipoContrato(): Observable<any> {
    return this.apiService.get(
      `${this.path}/api/enums/getAllTipoContrato`,
      this.getParams(),
      true
    );
  }

  getAllTipoEmpresa(): Observable<any> {
    return this.apiService.get(
      `${this.path}/api/enums/getAllTipoEmpresa`,
      this.getParams(),
      true
    );
  }

  getAllTipoProfissional(): Observable<any> {
    return this.apiService.get(
      `${this.path}/api/enums/getAllTipoProfissional`,
      this.getParams(),
      true
    );
  }

  getAllNacionalidadeEnum(): Observable<any> {
    return this.apiService.get(
      `${this.path}/api/enums/getAllNacionalidadeEnum`,
      this.getParams(),
      true
    );
  }

  getAllAcaoAtivityLogsEnum(): Observable<any> {
    return this.apiService.get(
      `${this.path}/api/enums/AcaoAtivityLogsEnum`,
      this.getParams(),
      true
    );
  }

  getAllEntidadeEnum(): Observable<any> {
    return this.apiService.get(
      `${this.path}/api/enums/EntidadeEnum`,
      this.getParams(),
      true
    );
  }

  list(params?: any): Observable<any> {
    return this.apiService.get<{ data: EspecialidadeFuncao[] }>(`${this.path}/getAllEspecialidadeFuncao`, params ? new HttpParams({
      fromObject: params
    }) : this.params).pipe(
      map(response => response)
    );
  }

  private getParams(params?: any): HttpParams {
    return params ? new HttpParams({ fromObject: params }) : new HttpParams();
  }
}
